// JSA Non-Employee Signatures Info
import { v4 as uuidv4 } from "uuid";

export class JsaNonEmployeeSignaturesInfo {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.nonEmployeeName = data.non_employee_name || "";
    this.nonEmployeeCompany = data.company_name || "";
    // Base64 encoded signature
    this.nonEmployeeSig = data.non_employee_sig
      ? "data:image/png;base64," + data.non_employee_sig
      : "";
  }

  // Updating the non-employee name
  updateNonEmployeeName(name) {
    this.nonEmployeeName = name;
  }

  // Updating the non-employee company
  updateNonEmployeeCompany(company) {
    this.nonEmployeeCompany = company;
  }

  // Updating the non-employee signature
  updateNonEmployeeSignature(signature) {
    if (!signature) {
      this.nonEmployeeSig = "";
    } else {
      this.nonEmployeeSig = signature;
    }
  }

  // To json for sending to the database
  toJson() {
    // Removing the data:image/png;base64, from the signature
    const nonEmployeeSig = this.nonEmployeeSig
      .replace("data:image/png;base64,", "")
      .trim();
    return {
      id: this.rowId,
      non_employee_name: this.nonEmployeeName,
      company_name: this.nonEmployeeCompany,
      non_employee_sig: nonEmployeeSig,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const patch = {
      patch_type: "jsa_non_emp_signatures",
      jsa_id: jsaId,
      id: this.rowId,
      action,
    };

    // Add non_employee_name if provided
    if (fields.nonEmployeeName !== undefined) {
      patch.non_employee_name = fields.nonEmployeeName;
    }

    // Add company_name if provided
    if (fields.nonEmployeeCompany !== undefined) {
      patch.company_name = fields.nonEmployeeCompany;
    }

    // Add non_employee_sig if provided (remove base64 prefix)
    if (fields.nonEmployeeSig !== undefined) {
      const cleanSig = (fields.nonEmployeeSig || "")
        .replace("data:image/png;base64,", "")
        .trim();
      patch.non_employee_sig = cleanSig;
    }

    return patch;
  }
}
